import {
  SIGN_IN_FAILURE,
  SIGN_IN_SUCCESS,
  SIGN_OUT_FAILURE,
  SIGN_OUT_SUCCESS,
  REFRESH_TOKEN,
  REFRESH_REFRESHTOKEN,
  SIGN_IN_LOADING
} from '../Types/authTypes';
import { jwtDecode } from 'jwt-decode';
import api from '../config/api';

export const login = (Email, password) => {
  // const dispatch = useDispatch();

  return dispatch => {
    dispatch({
      type: SIGN_IN_LOADING
    });
    return new Promise((resolve, reject) => {
      api
        .post(process.env.REACT_APP_API_URL + 'User/loginAdmin', {
          Email,
          password
        })

        .then(response => {
          // if (response.data.token) {
          //   // localStorage.setItem('accessToken', JSON.stringify(response.data.token));
          //   setToken(response.data.token);
          //   setRefreshToken(response.data.refresh_token);
          //   // localStorage.setItem('refreshToken', JSON.stringify(response.data.refreshToken));
          //   const user = jwtDecode(response.data.token);
          //   dispatch({
          //     type: SIGN_IN_SUCCESS,
          //     payload: {
          //       token: response.data.token,
          //       refreshToken: response.data.refreshToken,
          //       user: user
          //     }
          //   });
          // }
          resolve(response.data);
        })
        .catch(e => {
          if (!e.response) {
            dispatch({
              type: SIGN_IN_FAILURE,
              payload: 'Network Error'
            });
          } else {
            dispatch({
              type: SIGN_IN_FAILURE,
              payload: e.response.data.message
            });
          }
          reject(e.response.data);
        });
    });
  };
};

export const logout = () => {
  // localStorage.removeItem('accessToken');
  // localStorage.removeItem('refreshToken');
  // return dispatch => {
  //   dispatch({ type: SIGN_OUT_SUCCESS });
  //   window.location.pathname = '/signin';
  const refreshToken = getRefreshToken();
  return dispatch => {
    api
      .post(
        process.env.REACT_APP_API_URL + 'User/logout',
        {},
        {
          headers: {
            'x-refresh-token': refreshToken
          }
        }
      )
      .then(() => {
        // if (response.data.token) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        dispatch({ type: SIGN_OUT_SUCCESS });
        window.location.pathname = '/signin';
        // }
      })
      .catch(e => {
        if (!e.response) {
          dispatch({
            type: SIGN_OUT_FAILURE,
            payload: 'Network Error'
          });
        } else {
          dispatch({
            type: SIGN_OUT_FAILURE,
            payload: e.response.data.message
          });
        }
      });
  };
};

export const setToken = token => {
  localStorage.setItem('accessToken', JSON.stringify(token));
};

export const setRefreshToken = refreshToken => {
  localStorage.setItem('refreshToken', JSON.stringify(refreshToken));
};

export const getCurrentUser = () => {
  let currentUser: any = {};
  const userJson = localStorage.getItem('accessToken');
  currentUser = userJson !== null ? jwtDecode(userJson) : {};
  return currentUser;
};

export const getToken = () => {
  const token = localStorage.getItem('accessToken');
  return token !== null ? JSON.parse(token) : null;
};

export const getRefreshToken = () => {
  const token = localStorage.getItem('refreshToken');
  return token !== null ? JSON.parse(token) : null;
};

// export const refreshToken = accessToken => dispatch => {
//   dispatch({
//     type: REFRESH_TOKEN,
//     payload: accessToken
//   });
// };

export const refreshToken = accessToken => dispatch => {
  dispatch({
    type: REFRESH_TOKEN,
    payload: accessToken
  });
};

export const refreshRToken = refreshToken => dispatch => {
  dispatch({
    type: REFRESH_REFRESHTOKEN,
    payload: refreshToken
  });
};

export const isAuthenticated = () => {
  const token = localStorage.getItem('accessToken');
  return token ? true : false;
};

// export const verifCode = async data => dispatch => {
//   console.log('data', data);

//   return dispatch => {
//     console.log('enter in dispatch');

//     return new Promise((resolve, reject) => {
//       console.log('enter in promise');

//       axios
//         .post(process.env.REACT_APP_API_URL + 'verifCode', data)
//         .then(response => {
//           console.log('🚀 ~ .then ~ response:', response);
//           const user = jwtDecode(response.data.token);

//           dispatch({
//             type: SIGN_IN_SUCCESS,
//             payload: {
//               token: response.data.token,
//               refreshToken: response.data.refreshToken,
//               user: user
//             }
//           });

//           resolve(response);
//         })
//         .catch(e => {
//           console.log('🚀 ~ returnnewPromise ~ e:', e.response.data);
//           if (!e.response) {
//             dispatch({
//               type: SIGN_IN_FAILURE,
//               payload: 'Network Error'
//             });
//           } else {
//             dispatch({
//               type: SIGN_IN_FAILURE,
//               payload: e.response.data.message
//             });
//             reject(e);
//           }
//         });
//     });
//   };
// };

export const verifCode = data => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      api
        .post(`${process.env.REACT_APP_API_URL}User/verifCode`, data)
        .then(async response => {
          console.log('response', response);
          if (response.status == 201) {
            setToken(response.data.data.token);
            setRefreshToken(response.data.data.refresh_token);
            const user = jwtDecode(response.data.data.token);

            dispatch({
              type: SIGN_IN_SUCCESS,
              payload: {
                token: response.data.token,
                refreshToken: response.data.refreshToken,
                user: user
              }
            });
            resolve(response.data);
          } else {
            setToken(response.data.token);
            setRefreshToken(response.data.refresh_token);
            const user = jwtDecode(response.data.token);

            dispatch({
              type: SIGN_IN_SUCCESS,
              payload: {
                token: response.data.token,
                refreshToken: response.data.refreshToken,
                user: user
              }
            });
            resolve({ ...response.data, message: 'Logged In successfully' });
          }
        })
        .catch(error => {
          console.log('error', error);
          const errorMsg = error.response.data.message;
          dispatch({
            type: SIGN_IN_FAILURE,
            payload: error.response.data.message
          });
          reject(errorMsg);
        });
    });
  };
};

export const isValidToken = token => {
  return jwtDecode(token);
  //   let decoded = jwtDecode(token);
  //   return new Date(decoded.exp * 1000) > new Date() ? decoded : null;
};
export const forgotPassword = Email => {
  return new Promise((resolve, reject) => {
    api
      .post(process.env.REACT_APP_API_URL + 'User/forgotPassword', { Email })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response?.data || { message: 'Something went wrong' });
      });
  });
};
export const resetPassword = (email, code) => {
  return new Promise((resolve, reject) => {
    api
      .post(process.env.REACT_APP_API_URL + 'User/resetPassword', { email, code })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response?.data || { message: 'Invalid or expired validation code' });
      });
  });
};
